// extracted by mini-css-extract-plugin
module.exports = {"reports-search-bar":"ReportsSearch_reports-search-bar__Tsdyx","type-selector":"ReportsSearch_type-selector__E0fU5"};